export default __webpack_public_path__ + "static/media/JANDOM2026.fa407117.jpg";